module.exports = __webpack_public_path__ + "static/media/mf.e08dce50.svg";